import React from "react";
import { Grid } from "@mui/material";
import { ReferenceArrayInput, AutocompleteArrayInput } from "react-admin";
import { paymentRequests } from "api/paymentApi";

const Ibans = ({ isDisabled }) => {
  return (
    <>
      <Grid
        item
        md={5}
        xs={12}
      >
        <ReferenceArrayInput
          source="ibanIds"
          reference={paymentRequests.getIbansSelect()}
        >
          <AutocompleteArrayInput
            optionText="name"
            label="Iban"
            fullWidth
            readOnly={isDisabled}
          />
        </ReferenceArrayInput>
      </Grid>
    </>
  );
};

export default Ibans;
